import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  AGE_OPTIONS,
  AGE_QUESTION,
} from '~/pages/communication/age/libs/components/AgeCommunication/constants'
import { AgeCommunicationStyles as S } from '~/pages/communication/age/libs/components/AgeCommunication/styles'
import { AgeLegalConsent } from '~/shared/components/AgeLegalConsent'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { eventLogger } from '~/shared/services/eventLogger'
import { TPageProps } from '~/shared/types/commonTypes'

const AgeCommunication = ({ nextPagePath, pageId }: TPageProps) => {
  useTranslation('communication')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: AGE_QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.TitleGroup>
          <S.Title>
            <Trans
              ns="communication"
              i18nKey="onboarding.communicationAge.title"
            />
          </S.Title>
          <S.Subtitle>
            <Trans
              ns="communication"
              i18nKey="onboarding.communicationAge.subtitle"
            />
          </S.Subtitle>
        </S.TitleGroup>

        <S.Options>
          {AGE_OPTIONS.map(({ value, key }) => (
            <S.OptionButton
              key={key}
              $isSelected={answer === key}
              disabled={isAnswersDisabled}
              onClick={() => {
                if (isAnswersDisabled) return
                setAnswer(key)
                eventLogger.logBiUserAge(value, true)
                handleChange(key, handleContinue)
                setIsAnswersDisabled(true)
              }}
            >
              <S.OptionLabel>{value}</S.OptionLabel>
            </S.OptionButton>
          ))}

          <AgeLegalConsent />
        </S.Options>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default AgeCommunication
